module.exports = __webpack_public_path__ + "static/img/TBR.234a9a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/TBR.png
// module id = 7sIc
// module chunks = 1